import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import { IUserSettings, IUserSettingsUpdateRequest } from '../types/interfaces/ISettings';

export async function getMySettings(): Promise<ApiResponse<IUserSettings>> {
  return apiClient.get<IUserSettings>('/users/me/settings');
}

export async function updateMySettings(
  settings: IUserSettingsUpdateRequest
): Promise<ApiResponse<IUserSettings>> {
  return apiClient.put<IUserSettings>('/users/me/settings', settings);
}

export async function resetMySettings(): Promise<ApiResponse<IUserSettings>> {
  return apiClient.post<IUserSettings>('/users/me/settings/reset-defaults');
}
